import React, {useEffect, useState} from 'react';
import {ThemeType} from '@cci-shared/features/const/environment';
import environmentStore, {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {getLanguageType, SUPPORT_LANGUAGES_REGION, SupportLanguage} from '@di-shared/i18init';
import dateFnsFormat from 'date-fns/format';

const {setState, getState} = environmentStore;

function DevLocaleButton() {
  const theme = useEnvironmentStore((state) => state.theme);
  const language = useEnvironmentStore((state) => state.lang);
  const region = useEnvironmentStore((state) => state.region);
  const setTheme = useEnvironmentStore((state) => state.setTheme);
  const [isOpen, setIsOpen] = useState(false);
  const {setLanguage} = useInferableTranslation();

  useEffect(() => {
    const element = document.querySelector('.vc-switch') as HTMLElement;
    if (element) {
      element.style.display = 'none';
    }
  }, []);

  const languageButtons = (
    <select
      value={getLanguageType(language, region)}
      onChange={(e) => {
        const selectedLanguage = e.target.value as SupportLanguage;
        setLanguage(selectedLanguage);
        setState({lang: selectedLanguage});
      }}
      style={{textAlign: 'center'}}
    >
      {SUPPORT_LANGUAGES_REGION[region].map((languageType) => (
        <option
          key={languageType}
          value={languageType}
        >
          {languageType}
        </option>
      ))}
    </select>
  );

  const themeButtons = (Object.keys(ThemeType) as Array<ThemeType>).map((themeType) => (
    <div key={themeType}>
      <button
        type="button"
        style={{
          color: theme === themeType ? 'var(--secondary-high)' : 'var(--on-surface-container-high)',
          fontSize: 15,
        }}
        onClick={() => {
          setTheme(themeType === ThemeType.LIGHT ? ThemeType.LIGHT : ThemeType.DARK);
        }}
      >
        {themeType}
      </button>
    </div>
  ));

  const userAgentButtons = (
    <details onClick={() => window.navigator.clipboard.writeText(window.navigator.userAgent)}>
      <summary>userAgent</summary>
      {window.navigator.userAgent}
    </details>
  );

  const environmentButtons = (
    <details>
      <summary>environment</summary>
      <div>puid: {getState().puid}</div>
      <div>ccid: {getState().ccid}</div>
      <div>sub: {getState().sub}</div>
      <div>locale: {getState().locale}</div>
      <div>region: {getState().region}</div>
      <div>lang: {getState().lang}</div>
      <div>os: {getState().os}</div>
      <div>appVersion: {getState().appVersion}</div>
      <div>isWebview: {getState().isWebview}</div>
      <div>theme: {getState().theme}</div>
      <div>device: {getState().device}</div>
      <div>speedUnit: {getState().speedUnit}</div>
      <div>distanceUnit: {getState().distanceUnit}</div>
      <div>timezone: {getState().timezone}</div>
    </details>
  );

  const vConsoleButtons = (
    <button
      type="button"
      className="dev_button_small"
      onClick={() => {
        const element = document.querySelector('.vc-switch') as HTMLElement;
        if (element) {
          const currentDisplay = window.getComputedStyle(element).display;
          if (currentDisplay === 'none') {
            element.style.display = 'block';
          } else {
            element.style.display = 'none';
          }
        }
      }}
    >
      vConsole 보기
    </button>
  );

  return (
    <div style={{position: 'fixed', bottom: 0, right: 0, backgroundColor: '#ddd', padding: 5, zIndex: 9999}}>
      <button
        type="button"
        onClick={() => setIsOpen((isOpen) => !isOpen)}
        style={{color: '#666', padding: 4}}
      >
        {import.meta.env.VITE_BRAND}-{import.meta.env.VITE_PROFILE}Tool
      </button>
      {isOpen && (
        <div style={{marginTop: 5, fontSize: 17, display: 'flex', flexDirection: 'column', gap: 5}}>
          <div>build {dateFnsFormat(new Date(import.meta.env.VITE_BUILD_DATE), 'yyyy-MM-dd HH:mm')}</div>
          <div style={{display: 'flex', gap: '5px'}}>theme {themeButtons}</div>
          <div>language {languageButtons}</div>
          <div>{userAgentButtons}</div>
          <div>{environmentButtons}</div>
          <div>{vConsoleButtons}</div>
          <div onClick={() => (document.location.href = '/')}>page-list 이동</div>
        </div>
      )}
    </div>
  );
}

export default DevLocaleButton;
